function clamp (value, min, max) {
    if (value < min) return min
    if (value > max) return max
    return value
}

function updateQueryParams (currentParams, newParams) {
    const queryParams = { ...currentParams, ...newParams }
    return queryParams
}

function throttle(func, interval) {
    let lastCall = 0
    return function() {
        const timestamp = Date.now()
        const timeElapsed = timestamp - lastCall
        if (timeElapsed > interval) {
            func.apply(this, arguments)
            lastCall = timestamp
        }
    }
}

function generateRandomString (length, characters = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ') {
    let id = ''
    for (let i = 0; i < length; i += 1) {
        const randomIndex = Math.round(Math.random() * (characters.length - 1))
        id += characters[randomIndex]
    }
    return id
}

function highlightDifference (text, str) {
    const normalText = text.replace(
        new RegExp(`${str}`, 'gi'),
        (match) => `<span style="font-weight: normal">${match}</span>`
    )
    return `<span style="font-weight: bold">${normalText}</span>`
}

function isAlmostEqual (a, b, epsilon = Number.EPSILON) {
    return a >= b - epsilon && a <= b + epsilon
}

function lerp (a, b, t) {
    return a + (b - a) * clamp(t, 0, 1)
}

function truncate (text, maxLength) {
    if (text.length > maxLength) {
        return `${text.slice(0, maxLength).trim()}...`
    }
    return text
}

export default {
    clamp,
    updateQueryParams,
    throttle,
    generateRandomString,
    highlightDifference,
    isAlmostEqual,
    lerp,
    truncate
}
